import { ExtendedPatch } from "./extended";

export type EditOptions = {
  patches: ExtendedPatch[];
  inversePatches?: ExtendedPatch[];
};

export function addPathPrefixToEditOptions(
  editOptions: EditOptions,
  path: string[]
): EditOptions {
  return {
    patches: editOptions.patches.map((patch) => ({
      ...patch,
      path: [...path, ...patch.path],
    })),
    ...(editOptions.inversePatches
      ? {
          inversePatches: editOptions.inversePatches.map((patch) => ({
            ...patch,
            path: [...path, ...patch.path],
          })),
        }
      : {}),
  };
}
